// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6e18157f","845":"4bd646ea"}[chunkId] + ".chunk.js";
};